import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { Modal, Input, Button } from 'antd'
import {
  $cookie,
  isPhone,
  isCode,
  sessionstorage,
  getSuccessMsg
} from '$utils'
import { intentCommon } from '../service'
import { UseIntentOrderExt } from '../order-ext'
import { UseModalSuccess } from '../success'
import './styles.scss'

import imgPackage from '~/img/buy/package.png'
import $dom from '../../../util'

// 限时礼包弹窗显示, 下架车不显示，老客不显示  15s显示
const IntentDetailGift = (props) => {
  const { onClose, submitParams, otherParams } = props
  const [visible, setVisible] = useState(props.visible)
  const [mobileNumber, setMobileNumber] = useState(
    $cookie.get('rrc_login_phone') || sessionstorage.get('intentPhone') || ''
  )
  const [errMsg, setErrMsg] = useState()

  const [verify, setVerify] = useState({
    imgVerify: '', // 返回的防刷验证码图形
    imgVerifyCode: null, // 防刷验证码
    imgVerifyCodeValid: false // 防刷验证码校验
  })

  const closeModal = () => {
    global.$rbl.push('car-detail_detail-gifts_close')
    setVisible(false)
    onClose && onClose()
  }
  // 线索提交
  const giftSubmit = async (isrefresh) => {
    const _isrefresh = isrefresh && isrefresh === true
    if (!_isrefresh) {
      global.$rbl.push({
        event: 'car-detail_detail-gifts_gifts-submit',
        content: {
          param: submitParams.submit_sources
        }
      })
    }
    setErrMsg('')
    if (!isPhone(mobileNumber)) {
      setErrMsg('手机号输入有误')
      return
    }
    if (!_isrefresh && verify.imgVerify && !verify.imgVerifyCodeValid) {
      setErrMsg('验证码输入有误')
      return
    }
    const params = {
      ...submitParams,
      mobile_number: mobileNumber,
      model_name: 'time_limit_appointment'
    }
    if (verify.imgVerify) {
      params.verify_code = verify.imgVerifyCode
    }
    try {
      const result = await intentCommon(params)
      global.$rbl.push(`${submitParams.submit_sources}-提交成功`)
      $dom.popLayerSubmit()
      // campaignParticipate({
      //   phone: mobileNumber,
      //   key: 'PCXSLB200',
      //   submit_sources: submitParams.submit_sources
      // })
      if (result.data.display_next_page === true) {
        const nextSubmitParams = {
          ...submitParams,
          phone: mobileNumber,
          sub_product: 'appointment',
          model_name: 'time_limit_appointment'
        }
        new UseIntentOrderExt({
          modelName: 'time_limit_appointment',
          submitParams: nextSubmitParams,
          otherParams,
          profile: result.data.profile
        }).open()
      } else {
        const showSuccess = () => {
          new UseModalSuccess({
            msg:
              result.data.notice_message
              || getSuccessMsg('time_limit_appointment'),
            ino: otherParams.ino
          }).open()
        }
        // 未登录提交信息补充后，应该弹出登录弹窗，并发送短信验证码
        if (
          !$cookie.get('rrc_login_phone')
          && !$cookie.get('rrc_login_token')
        ) {
          sessionstorage.set('loginBackModalInfo', {
            msg:
              result.data.notice_message
              || getSuccessMsg('time_limit_appointment'),
            ino: otherParams.ino
          })
          window.location.href = `${
            window.location.origin
          }/login?source=${encodeURIComponent(window.location.href)}`
          // new UseLogin({
          //   isAutoMsg: false,
          //   isAutoLogin: true,
          //   phone: mobileNumber,
          //   onSuccessCallBack: () => {
          //     showSuccess()
          //   }
          // }).open()
        } else {
          showSuccess()
        }
      }
      closeModal()
    } catch (error) {
      if (error.status === 200) {
        const result = error.data
        if (result.status === 400) {
          // 图形验证码
          global.$rbl.push({
            event: 'm_verification_show',
            content: { param: 'verification' }
          })
          setVerify({ ...verify, imgVerify: result.image })
        }
      }
    }
  }
  return (
    <Modal
      centered
      visible={visible}
      footer={null}
      bodyStyle={{ padding: '0px' }}
      onCancel={closeModal}
    >
      <div className="r-intent-detail-gift">
        <div className="logo">
          <img src={imgPackage} alt="预约看车送好礼" />
        </div>
        <h2 className="title">预约看车送好礼!</h2>
        <h3 className="sub-title">现在预约看车，限时派送购车基金</h3>
        <Input
          onClick={() => {
            global.$rbl.push('car-detail_detail-gifts_phone-input')
          }}
          size="large"
          className="phone"
          placeholder="请输入您的手机号"
          maxLength={11}
          suffix={<i className="iconfont icon-shouji" />}
          value={mobileNumber}
          onChange={(e) => {
            setMobileNumber(e.target.value)
          }}
        />
        {/* 防刷验证码 */}
        {verify.imgVerify && (
          <div className="img-verify">
            <Input
              className="brush-code"
              size="large"
              placeholder="请输入验证码"
              bordered="false"
              maxLength={4}
              value={verify.imgVerifyCode}
              onChange={(e) => {
                setVerify({
                  ...verify,
                  imgVerifyCode: e.target.value,
                  imgVerifyCodeValid: isCode(e.target.value)
                })
              }}
            />
            <div className="brush-wrapper" onClick={() => giftSubmit(true)}>
              <img
                className="brush-img"
                src={verify.imgVerify}
                alt="验证码图片"
              />
              <div className="brush-refresh" />
            </div>
          </div>
        )}
        <p className="err-msg">{errMsg}</p>
        <Button
          size="large"
          type="primary"
          block
          className="submit"
          onClick={giftSubmit}
        >
          领取
        </Button>
        <p className="tip clearfix">*请到人人车APP上查看该优惠券</p>
      </div>
    </Modal>
  )
}

IntentDetailGift.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  submitParams: PropTypes.object,
  otherParams: PropTypes.object
}

IntentDetailGift.defaultProps = {
  visible: false,
  onClose: null,
  submitParams: null,
  otherParams: null
}

function mountAnywhere(Comp, root) {
  const div = document.createElement('div');
  (root || document.body).appendChild(div)
  // 向组件注入 onClose 方法，以便组件能调用关闭
  const Clone = React.cloneElement(Comp, {
    onClose: () => {
      ReactDOM.unmountComponentAtNode(div)
      div.parentNode.removeChild(div)
    }
  })
  ReactDOM.render(Clone, div)

  return div
}

export class UseIntentDetailGift {
  constructor(params) {
    this.visible = false
    this.ref = null
    this.submitParams = params.submitParams
    this.otherParams = params.otherParams
  }

  open() {
    this.visible = true
    this.ref = mountAnywhere(
      <IntentDetailGift
        visible={this.visible}
        submitParams={this.submitParams}
        otherParams={this.otherParams}
      />
    )
    return this.ref
  }

  close() {
    this.visible = false
  }
}
export default IntentDetailGift
